import React from 'react';
import { ImagePlaceholder, StarRating, SectionWrapper } from './ui';
export const TopTrustBar = () => {
  const text = 'FREE SHIPPING · 60-DAY MONEY-BACK GUARANTEE · 30,000+ FAMILIES PROTECTED · CHEMICAL-FREE · ';
  return <div className="w-full bg-primary text-white text-xs font-bold tracking-widest py-2 overflow-hidden sticky top-0 z-50" data-id="element-60">
      <div className="whitespace-nowrap flex animate-marquee" data-id="element-61">
        <span className="mx-4" data-id="element-62">{text}</span>
        <span className="mx-4" data-id="element-63">{text}</span>
        <span className="mx-4" data-id="element-64">{text}</span>
        <span className="mx-4" data-id="element-65">{text}</span>
      </div>
    </div>;
};
export const Masthead = () => {
  return <div className="w-full border-b border-sage/50 py-4 px-5 flex justify-center" data-id="element-66">
      <div className="w-full max-w-[720px] text-[10px] sm:text-xs font-bold tracking-widest uppercase text-foreground/60" data-id="element-67">
        THE FAMILY OUTDOORS DISPATCH <span className="mx-1 sm:mx-2" data-id="element-68">|</span>{' '}
        Trending in Family Health <span className="mx-1 sm:mx-2" data-id="element-69">|</span> Home ›
        Tick-Borne Illness › The Missing Fourth Layer
      </div>
    </div>;
};
export const Hero = () => {
  return <SectionWrapper className="pt-8 md:pt-12 pb-6 md:pb-10" isWide={true} data-id="element-70">
      <div className="max-w-[720px] mx-auto" data-id="element-71">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-primary leading-tight mb-6" data-id="element-72">
          There's a Tick on Your Street Right Now That Can Make Your Daughter
          Allergic to Hamburgers for Life.
        </h1>

        <p className="text-lg sm:text-xl font-bold text-foreground/90 leading-relaxed mb-6" data-id="element-73">
          You spray. You check. You comb. And you still find them — because the
          threat changed and the playbook didn't. Your three-layer defense may
          have a fourth-layer gap — and here's what every Lyme-belt parent needs
          to know before another summer of white-knuckle bedtime scalp checks.
        </p>

        <div className="flex items-center gap-3 mb-8 pb-8 border-b border-sage/50" data-id="element-74">
          <StarRating rating={4.8} data-id="element-75" />
          <span className="text-sm font-medium text-foreground/80" data-id="element-76">
            <span className="font-bold" data-id="element-77">4.8 / 5</span> — based on 7,341 verified
            family reviews
          </span>
        </div>
      </div>

      <figure className="w-full mt-8 flex flex-col" data-id="element-78">
        <div className="w-full aspect-[4/3] md:aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-79">
          <img src="https://cdn.magicpatterns.com/uploads/qia1LbdviUFnxzB97tHAZe/75114dfd-5197-4de7-bab1-db1d339eafdb.png" alt="A six-year-old girl sits cross-legged in mid-summer tall grass at the edge of a backyard during golden hour, wearing a pink t-shirt, with a triangular black LEVANCE device clipped to her backpack strap. Her mother watches relaxed from the deck in the background." className="w-full h-full object-cover" data-id="element-80" />
        </div>
        <figcaption className="mt-3 text-sm italic text-foreground/80 text-center px-4" data-id="element-81">
          "The fourth layer of tick protection your pediatrician hasn't told you
          about yet."
        </figcaption>
      </figure>
    </SectionWrapper>;
};